import { Box, Container, useMediaQuery } from "@mui/material";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import React from "react";
import { useTheme } from "@mui/material";
import { useCompany } from "../../context/CompanyContext";
import NoAccessPage from "../pages/no-access";
const Layout = () => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const theme = useTheme();
    const HEADER_HEIGHT = isMobile ? 16 : 32;
    const { hasNoAccess, isLoadingCompanies } = useCompany();
    // Show loader while checking companies
    // if (isLoadingCompanies) {
    //   return (
    //     <Box
    //       sx={{
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         height: "100vh",
    //         width: "100%",
    //         backgroundColor: theme.palette.background.default,
    //       }}
    //     >
    //       <WidgetLoader isLoading={true} />
    //     </Box>
    //   );
    // }
    // Show no access page if user has no companies assigned
    if (hasNoAccess && !isLoadingCompanies) {
        return React.createElement(NoAccessPage, null);
    }
    return (React.createElement(Box, { sx: {
            maxWidth: "100vw",
            width: "100%",
            height: "100dvh",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            backgroundColor: theme.palette.primary.darker,
            overflow: "hidden", // Prevent scroll on background
        } },
        React.createElement(Box, { sx: {
                position: "absolute",
                backgroundImage: "url(/assets/images/bg-vector.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                zIndex: 1, // Sit behind everything
                left: "40px",
                top: "-100px",
                width: "700px",
                height: "400px",
                pointerEvents: "none",
            } }),
        React.createElement(Header, null),
        React.createElement(Container, { sx: {
                flexGrow: 1,
                backgroundColor: theme.palette.background.default,
                //overflow: "auto",
                pb: isMobile ? 2 : 0.5,
                borderTopLeftRadius: 64,
                marginLeft: isTablet ? 1 : 2.5,
                pt: `${HEADER_HEIGHT}px`,
                pl: 3.5,
                pr: isTablet ? 4 : 6,
                position: "relative",
                zIndex: 2, // Higher than background
            }, disableGutters: true, maxWidth: false },
            React.createElement(Outlet, null))));
};
export default Layout;
